import { ofType, combineEpics } from 'redux-observable';
import {
  filter, first, tap, ignoreElements,
} from 'rxjs/operators';

import { actions } from '@ezugi/bootstrap';
import { NO_MORE_BETS } from '@ezugi/constants';

import { isSicboMultiplierSelector } from '../../selectors/game';

const {
  appActions: { app },
  roundActions: { round },
} = actions;

/**
 * Preload font used for Sic Bo Multiplier
 * Canvas WinMessage animation
 */
function preloadFonts(action$, state$) {
  return action$.pipe(
    ofType(app.start),
    filter(() => isSicboMultiplierSelector(state$.value)),
    tap(() => {
      document.fonts.load('1em "BuiltTitlingRegular"');
    }),
    ignoreElements()
  );
}

const preloadWinMessage = (action$) => action$.pipe(
  ofType(round.set),
  filter(({ payload }) => payload.roundStatus === NO_MORE_BETS),
  first(),
  tap(() => {
    import('../../../components/GameResults/ResultMessage');
  }),
  ignoreElements(),
);

export default combineEpics(
  preloadFonts,
  preloadWinMessage,
);
